/**
 * Informational notice codes the backend can append to the external sign-in handoff redirect
 * (`&notice=<code>` beside `&handoff=`, see `SigningInComponent`). The sign-in already SUCCEEDED — a notice is
 * never an error and must never block, delay or undo the landing; it only decides what the app explains once
 * the user is inside.
 *
 * Mirrors codes from `API.Core/Authorization/AuthErrorCodes.cs`. Kept as a const object (not a hard-coded string
 * literal at the comparison site) so the mapping lives in one place.
 *
 * A code's catalog HTTP status is irrelevant here: it describes the REST answer that code produces on its own
 * endpoint, not this redirect, where the sign-in worked.
 */
export const SocialLoginNotice = {
  /**
   * An invitation was redeemed for a scope where the account already holds every role it offers, so it conferred
   * nothing. The session is issued anyway — and the invitation stays redeemable, because it was never consumed.
   * See docs/articles/authentication/legacy-login-claim.md.
   */
  InvitationAlreadyHeld: 'E_GRANT_ALREADY_HELD'
} as const;

/** Every notice code the SPA knows how to render. */
export type SocialLoginNoticeCode = typeof SocialLoginNotice[keyof typeof SocialLoginNotice];
